import { Create, Box, TextField } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object({
  bot_exchange_id: Yup.number().required(),
  credential_account_id: Yup.number().required(),
});

interface formDataType {
  bot_exchange_id: number;
  credential_account_id: number;
}

export const BotAffiliateCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("bot_exchange_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.bot_exchange_id}
          helperText={(errors as any)?.bot_exchange_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Bot Exchange Id"
          name="bot_exchange_id"
        />
        <TextField
          {...register("credential_account_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.credential_account_id}
          helperText={(errors as any)?.credential_account_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Credential Account Id"
          name="credential_account_id"
        />
      </Box>
    </Create>
  );
};
